import { LoginPage } from '@/imports/ui/pages/account-management/LoginPage';

export default LoginPage;
